// extracted by mini-css-extract-plugin
export default {"invoicePage":"Invoice_invoicePage__sA9lE","buttonCenter":"Invoice_buttonCenter__fBNGz","titleGroup":"Invoice_titleGroup__MYaU9","title":"Invoice_title__87DA5"};